





















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import NoteCreationDialog from "@/components/CollectionEvents/NoteCreationDialog.vue";
import { CollectionNoteModel, getCollectionNotes, saveCollectionNote } from "@/api/Notes";
import { CollectionEventDetailsModel } from "@/api/CollectionEvents";
import { LoadingStore } from "@/store/loadingStore";
import { Observer } from "mobx-vue";
import userStore from "@/store/userStore";
import notificationStore from "../../store/notificationStore";
import { deleteCollectionNote } from "@/api/Notes";

@Observer
@Component({ components: { NoteCreationDialog } })
export default class Notes extends Vue {
  @Prop(Object) readonly collectionEvent?: CollectionEventDetailsModel;
  notes: CollectionNoteModel[] = [];
  headers = [
    { text: "Note", value: "createdAt", width: "30%" },
    { text: "", value: "text", sortable: false, width: "70%" }
  ];
  loading = new LoadingStore();
  isCreationDialogOpen = false;

  async mounted() {
    await this.fetchData();
  }

  @Watch("collectionEvent")
  private onCollectionEventChange() {
    this.fetchData();
  }

  private async fetchData() {
    if (!this.collectionEvent || !this.collectionEvent.addressStreetName) return;

    const request = {
      addressUnitNo: this.collectionEvent.addressUnitNo,
      addressStreetNo: this.collectionEvent.addressStreetNo,
      addressStreetName: this.collectionEvent.addressStreetName,
      addressSuburbName: this.collectionEvent.addressSuburbName,
      addressStateCode: this.collectionEvent.addressStateCode,
      addressPostCode: this.collectionEvent.addressPostCode,
      addressCountry: this.collectionEvent.addressCountry,
      council: userStore.activeCouncil || ""
    };
    await this.loading.track(async () => {
      try {
        this.notes = await getCollectionNotes(request);
      } catch (error) {
        notificationStore.error("An unexpected error occurred while loading letter history");
      }
    });
  }

  async createNote(note: string) {
    await this.loading.track(async () => {
      const request = {
        addressUnitNo: this.collectionEvent?.addressUnitNo,
        addressStreetNo: this.collectionEvent?.addressStreetNo,
        addressStreetName: this.collectionEvent?.addressStreetName,
        addressSuburbName: this.collectionEvent?.addressSuburbName,
        addressStateCode: this.collectionEvent?.addressStateCode,
        addressPostCode: this.collectionEvent?.addressPostCode,
        addressCountry: this.collectionEvent?.addressCountry,
        createdAt: new Date(),
        note
      };

      const response = await saveCollectionNote(request);

      this.notes.push(response.note);
      this.isCreationDialogOpen = false;
    });
  }

  async deleteNote(item: CollectionNoteModel) {
    await this.loading.track(async () => {
      const request = {
        id: item.id
      };

      await deleteCollectionNote(request);

      this.notes = this.notes.filter(x => x.id != item.id);
    });
  }

  canDelete(item: CollectionNoteModel) {
    const currentUserId = userStore.user?.profile.sub.toLocaleLowerCase();

    if (!currentUserId) {
      return false;
    }

    return item.createdById !== currentUserId;
  }
}
